<template>
  <div class="dd-header">
    <div class="content">
      <div class="logo"><img :src="require('@/assets/logo-vertical.svg')"/></div>
      <div class="text" v-if="authenticated">
        קופת הגמל להשקעה
        של {{ activeMemberFirstName }}
      </div>
      <div class="text" v-else>
        <div v-if="isReduceMonthlyDeposit">
          שינויים בחיסכון - מה שהכי נכון לך עכשיו
        </div>
        <div v-else>
          איזה כיף שהחיסכון שלך הולך לגדול!
        </div>
      </div>
      <div class="shapes"><img :src="require('@/assets/dynamic-deposit/shapes.svg')"/></div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  name: 'DDHeader',
  props: {
    authenticated: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters('session', ['activeMemberFirstName']),
    ...mapGetters('dynamicSavings', ['isReduceMonthlyDeposit']),
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';

.dd-header {
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: $riseup_green;

  .content {
    display: flex;

    div {
      display: flex;
      justify-content: center;
      flex-direction: column;
    }

    .text {
      text-align: right;

      color: $riseup_white;
      font-family: SimplerProBold;
      font-size: 18px;
      line-height: 20px;
    }

    .logo {
      margin: 0px 25px;
    }

    .shapes {
      margin-right: 10px;
    }
  }
}
</style>
